// extracted by mini-css-extract-plugin
module.exports = {"rowTitle":"deliveryTitle_rowTitle__1m848","aliasContainer":"deliveryTitle_aliasContainer__uVBfO"};